var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"component-leadattachments"},[_c('AttachmentsList',{attrs:{"editable":_vm.isEditable,"deletable":_vm.isDeletable,"excludeParentAttachments":_vm.isChildLead,"showType":"","showDate":"","showSize":"","showEmpty":"","showFilters":""}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }